module.exports = "fragment ExpenseReload on ExpenseReload {\n  purchaseAmount\n  threshold\n  enabled\n}\n"